import { Static, Optional, String, Object, Number, Array, Omit } from '@sinclair/typebox';

import { RevenueFlightOffersRequestQuery } from '../revenue-flight-offers';

export type DateTab = Static<typeof DateTab>;
export const DateTab = Object({
  date: String(),
  price: Number(),
});

export type UpsellDateTabsResponse = Static<typeof UpsellDateTabsResponse>;
export const UpsellDateTabsResponse = Object({
  outbound: Array(DateTab),
  inbound: Optional(Array(DateTab)),
});

const CommonRevenueQueryParams = Omit(RevenueFlightOffersRequestQuery, ['outboundDate', 'inboundDate']);

export type UpsellDateTabsRequestQueryParams = Static<typeof UpsellDateTabsRequestQueryParams>;
export const UpsellDateTabsRequestQueryParams = Object({
  ...CommonRevenueQueryParams.properties,
  outboundMonth: Optional(String()),
  inboundMonth: Optional(String()),
  outboundDate: Optional(String()),
  inboundDate: Optional(String()),
});
